/**
 * @generated SignedSource<<2db4ccec1473e6e3aeab535278aa079d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AppointmentForm_query$data = {
  readonly clinicians: {
    readonly nodes: ReadonlyArray<{
      readonly rowId: any;
      readonly user: {
        readonly firstName: string;
        readonly lastName: string;
      } | null;
    }>;
  } | null;
  readonly services: {
    readonly nodes: ReadonlyArray<{
      readonly duration: {
        readonly minutes: number | null;
      };
      readonly name: string;
      readonly rowId: any;
    }>;
  } | null;
  readonly " $fragmentType": "AppointmentForm_query";
};
export type AppointmentForm_query$key = {
  readonly " $data"?: AppointmentForm_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"AppointmentForm_query">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rowId",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AppointmentForm_query",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "orderBy",
          "value": [
            "USER_BY_USER_ID__FIRST_NAME_ASC",
            "USER_BY_USER_ID__LAST_NAME_ASC"
          ]
        }
      ],
      "concreteType": "CliniciansConnection",
      "kind": "LinkedField",
      "name": "clinicians",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Clinician",
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "User",
              "kind": "LinkedField",
              "name": "user",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "firstName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "lastName",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "clinicians(orderBy:[\"USER_BY_USER_ID__FIRST_NAME_ASC\",\"USER_BY_USER_ID__LAST_NAME_ASC\"])"
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "orderBy",
          "value": [
            "NAME_ASC"
          ]
        }
      ],
      "concreteType": "ServicesConnection",
      "kind": "LinkedField",
      "name": "services",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Service",
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Interval",
              "kind": "LinkedField",
              "name": "duration",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "minutes",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            (v0/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": "services(orderBy:[\"NAME_ASC\"])"
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "a5f09e562e1a290b189f5ce5304e717a";

export default node;
